(function () {
    angular
        .module("dashboard")
        .controller("OrderUpConfirmOrderStatusUpdateModalController", [
            "$scope",
            "$uibModalInstance",
            "OrderUpOrdersService",
            "PermissionService",
            "notify",
            "isCollect",
            "orderGuid",
            "notificationsEnabled",
            "deliveryIsTrackable",
            "callback",
            OrderUpConfirmOrderStatusUpdateModalController ]);

    function OrderUpConfirmOrderStatusUpdateModalController(
        $scope,
        $uibModalInstance,
        orderUpOrderService,
        permissionService,
        notify,
        isCollect,
        orderGuid,
        notificationsEnabled,
        deliveryIsTrackable,
        callback
    ) {
        $scope._notifier = notify;
        $scope.isCollect = isCollect;
        $scope.orderGuid = orderGuid;
        $scope.notificationsEnabled = notificationsEnabled;
        $scope.isEligibleForNotifications = isCollect || !deliveryIsTrackable;
        $scope.callback = callback;
        $scope.cancel = function () {
            $uibModalInstance.close();
        };
        $scope.markReady = async function () {
            $scope.isLoading = true;
            try {
                await orderUpOrderService.markOrderReady(
                    $scope.orderGuid
                );
                $scope.callback();
                $uibModalInstance.close();
            } catch (e) {
                console.error(e);
                $scope._notifier.error("Could not mark order as ready. Please try again.");
            } finally {
                $scope.isLoading = false;
            }
        }
    }
})();
